import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { setCommuneSlug } from '../lib/axios';
import { useAuth } from '../hooks/useAuth';
import { useImpersonation } from './ImpersonationContext';
/**
 * Single source of truth for the `X-Commune-Slug` header sent by axios.
 *
 * The effective commune is derived: an active impersonation (super admin)
 * always takes precedence over the logged-in user's own commune. Centralising
 * this here removes the refresh race where AuthContext, ImpersonationContext and
 * this provider each wrote the slug independently — on reload, AuthContext's
 * async /auth/me would resolve last and overwrite an impersonated slug with null
 * (super admins have no commune), leaving the sidebar without a tenant header and
 * therefore without navigation.
 */
export function CommuneProvider({ children }) {
    const { user } = useAuth();
    const { impersonated } = useImpersonation();
    const slug = impersonated?.slug ?? user?.commune?.slug ?? null;
    // Applied during render (not in an effect): CommuneProvider is an ancestor of
    // the sidebar, so it renders first — the axios header is set before any child
    // query is created. An effect runs child-first (too late: the sidebar's query
    // would fire with a stale/null slug on the first paint after a reload).
    setCommuneSlug(slug);
    return _jsx(_Fragment, { children: children });
}
